import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/private/sidebar";

const PrivateLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      
      <Sidebar onCollapseChange={setCollapsed} />

      <main
        className="flex-grow-1 p-0"
        style={{
          marginLeft: collapsed ? "70px" : "270px", 
          transition: "margin-left 0.3s ease",
          backgroundColor: "#F5F5F5"
        }}
      >
        <Outlet />
      </main>

    </div>
  );
};

export default PrivateLayout;
